// Recovers the filename the backend proposed via
// `Content-Disposition: attachment; filename="..."` (or the RFC 5987
// `filename*=UTF-8''...` form), so downloads use the server's naming instead
// of one guessed on the client, when the backend supplies it.
export function getFilenameFromContentDisposition(
  contentDisposition: string | undefined
): string | undefined {
  if (!contentDisposition) return undefined;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      // fall through to the plain filename form below
    }
  }

  const asciiMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  return asciiMatch ? asciiMatch[1].trim() : undefined;
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
